import apiService from "./api";

const mealService = {
  getMealById(mealId) {
    return apiService.get("/meals/" + mealId);
  },
  getFoods() {
    return apiService.get("/foods");
  },
  getFoodSizes() {
    return apiService.get("/foods/sizes");
  },
  getSideDishes() {
    return apiService.get("/foods/prilog");
  },
  getParentFoods(restaurantId) {
    return apiService.post("/foods/get-parent-foods", {
      restaurant: restaurantId,
    });
  },
  cloneParentFoods(cloneData) {
    return apiService.post("/foods/add-parent-foods", { clone: cloneData });
  },
  setDailyOffer(food) {
    return apiService.post("/foods/set-daily-offer", {
      food: food,
      id: food.id,
    });
  },
  deleteFoodImage(foodId) {
    return apiService.delete("/foods/food-image-delete/" + foodId);
  },
  createFood(foodData) {
    return apiService.post("/foods", foodData);
  },
  updateFood(foodId, foodData) {
    return apiService.put("/foods/" + foodId, foodData);
  },
  deleteFood(foodId) {
    return apiService.delete("/foods/" + foodId);
  },
  changeReservedMeal(data) {
    return apiService.post("/meals/change-reserved-meal", data);
  },
  getReservedMeal(restaurantId, date) {
    return apiService.post(`/meals/reserved-meal?restoran=${restaurantId}&date=${date}`);
  },
};

export default mealService;
